var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainHeroMenu"},[_c('ul',{attrs:{"id":"mainHeroMenuList"}},_vm._l((_vm.menuList),function(menuItem){return _c('MenuItem',{key:_vm.buildKey(menuItem),attrs:{"item":menuItem}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }